<template>
	<div>
		<el-collapse v-model="activeName" accordion style="margin-left:40px;margin-right:20px;">
			<el-collapse-item name="1">
		    <template slot="title">
		      <h3><i class="mdi mdi-book"></i>{{ $t('clients.classification') }}</h3>
		    </template>
				<el-form label-position="left" >
					<el-row :gutter="20">
						<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
							<el-form-item :label="$t('clients.class')">
							 <el-select
									 v-model="customerClasseModel"
									 :clearable="true"
									 placeholder="Type"
									 value-key="id">
									 <el-option
										 v-for="item in customerClasses"
										 :key="item.id"
										 :label="item.code"
										 :value="item">
									 </el-option>
								 </el-select>
						 </el-form-item>
						</el-col>
						<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
							<el-form-item :label="$t('clients.tags')">
						    <el-select
						    		v-model="tagsModel"
				  					multiple
								    filterable
								    allow-create
								    value-key="id">
								    <el-option
								      v-for="item in listTags"
								      :key="item.id"
								      :label="item.code"
								      :value="item">
								    </el-option>
							  	</el-select>
						  </el-form-item>
						</el-col>
					</el-row>


				</el-form>
		  </el-collapse-item>
			<el-collapse-item name="2">
		    <template slot="title">
		      <h3><i class="mdi mdi-earth"></i>{{ $t('clients.currencyLanguage') }}</h3>
		    </template>
				<el-form :label-position="'top'" >
					<el-row :gutter="20">
						<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
							<el-form-item :label="$t('clients.currency')">
		 					 <el-select
		 							 v-model="currencyModel"
		 							 filterable
		 							 default-first-option>
		 							 <el-option
		 								 v-for="item in currencies"
		 								 :key="item.id"
		 								 :label="item.code"
		 								 :value="item.id">
		 							 </el-option>
		 						 </el-select>
		 				 </el-form-item>
						</el-col>
						<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
							<el-form-item :label="$t('clients.language')">
		 					 <el-select
		 							 v-model="languageModel"
		 							 filterable
		 							 default-first-option>
		 							 <el-option
		 								 v-for="item in languages"
		 								 :key="item.id"
		 								 :label="item.name"
		 								 :value="item.id">
		 							 </el-option>
		 						 </el-select>
		 				 </el-form-item>
						</el-col>
					</el-row>


			 </el-form>
		  </el-collapse-item>
			<el-collapse-item name="3" v-if="isInvoicingModuleactive === true">
		    <template slot="title">
		      <h3><i class="mdi mdi-credit-card-outline"></i> {{ $t('clients.paymentOptions') }}</h3>
		    </template>
				<p>{{$t('clients.selectPaymentInstruction')}}</p>
				<el-checkbox-group v-model="paymentMethodModel">
					<el-checkbox v-for="p in onlinePaymentMethods" :key="p.id" :label="p.id">{{$t('invoices.'+p.code)}}</el-checkbox>
				</el-checkbox-group>
		  </el-collapse-item>
			<el-collapse-item name="4" v-if="isInvoicingModuleactive">
		    <template slot="title">
		      <h3><i class="mdi mdi-file-document"></i> {{$t('clients.invoicing')}}</h3>
		    </template>
				<el-form :label-position="'top'">
					<el-form-item :label="$t('clients.invoicingOption')">
						<el-switch v-model="onlineInvoiceIndModel" :active-text="$t('clients.onlineInvoicing')" :inactive-text="$t('clients.manualInvoicing')">
						</el-switch>
					</el-form-item>
					<el-form-item :label="$t('clients.invoiceBeforeProcessOrder')">
						<el-switch v-model="invoiceBeforeProcessingModel">
						</el-switch>
					</el-form-item>
					<el-form-item :label="$t('clients.terms')">
						<el-select v-model="termModel" :placeholder="$t('clients.terms')" value-key="id">
							<el-option
							v-for="t in terms"
							:key="t.id"
							:label="$t('invoices.terms.'+t.label)"
							:value="t">
							</el-option>
						</el-select>
					</el-form-item>
	    		<!-- <el-form-item label="Facturer des frais de retard?">
			    	<el-switch
						  v-model="lateFeeActivatedModel"
						  active-color="#5f8fdf"
  						  inactive-color="#dcdfe6">
						</el-switch>
					</el-form-item>
					<el-form-item label="Combien?" >
					    <div style="margin-bottom:10px">
							<el-radio v-model="indTypeFeeModel" :label="0"  :disabled="!settings.lateFeeActivated">Pourcentage</el-radio>
							<el-radio v-model="indTypeFeeModel" :label="1"  :disabled="!settings.lateFeeActivated">Frais fixe</el-radio>
						</div>
						<div v-if="settings.indTypeFeeModel=='0'">
							<el-col :span="8">
								<el-input-number size="small" style="width:130px;margin-top:2px;" v-model="feeModel" :disabled="!settings.lateFeeActivated" :min="1" :max="100"></el-input-number>
								<span class="ml-10 mr-10">% de la facture</span>
								</el-col>

					   </div>
					   <div v-else>
							<el-col :span="11">
								 <el-input-number size="small"  style="margin-top:2px;" v-model="feeModel" :disabled="!settings.lateFeeActivated" :min="1"></el-input-number>
								 <span class="ml-10 mr-10">$ (frais fixe)</span>
									</el-col>

					   </div>
				  	</el-form-item>
				  	<el-form-item label="Quand?" >
							<el-col :span="8">
								  <el-input-number size="small"  style="width:130px;margin-top:2px;" v-model="gracePeriodModel" :disabled="!settings.lateFeeActivated" :min="1" :max="365"></el-input-number>
									<span class="ml-10 mr-10">jours après la date limite</span>
						   	</el-col>

				  	</el-form-item> -->
						<!-- <el-form-item :label="$t('clients.taxes')" >
							<el-select v-model="taxesModel" multiple :placeholder="$t('common.select.placeholder')" value-key="id">
								<el-option
									v-for="t in taxes"
									:key="t.id"
									:label="t.name"
									:value="t">
								</el-option>
							</el-select>
						</el-form-item> -->
						<el-form-item :label="$t('clients.taxes')" >
							<el-radio-group v-model="taxableModel">
								<el-radio-button :label="true">Charger les taxes</el-radio-button>
								<el-radio-button :label="false">Ne pas charger les taxes</el-radio-button>
							</el-radio-group>
						</el-form-item>
				</el-form>
		  </el-collapse-item>
			<el-collapse-item name="5">
		    <template slot="title">
		      <h3><i class="mdi mdi-truck-delivery"></i> {{$t('clients.deliveryPref')}}</h3>
		    </template>
				<el-form :label-position="'top'">
					<el-row :gutter="20">
						<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
							<el-form-item :label="$t('clients.deliveryType')">
								<el-select v-model="deliveryTypeModel" placeholder="" clearable value-key="id" @change="selectDeliveryType">
									<el-option
										 v-for="type in deliveryTypesByLanguage($i18n.locale)"
										 :key="type.id"
										 :label="type.name"
										 :value="type" >
									 </el-option>
		           </el-select>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
							<el-form-item label="Succursale" v-if="settings.deliveryType!=null && settings.deliveryType.choice_custom_info!=null">
								<el-autocomplete class="inline-input" v-model="location" style="width:100%;" :fetch-suggestions="searchLocation" placeholder="Sélectionner une succursale" @select="handleSelectLocation">
									<i
										class="el-icon-search el-input__icon"
										slot="suffix">
									</i>
									<template slot-scope="{ item }">
										<BranchTile :location="item.content"></BranchTile>
									</template>
								</el-autocomplete>
							</el-form-item>
						</el-col>
					</el-row>


					<el-form-item :label="$t('clients.standardDeliveryCalendar')">
						<CustomerDeliveryCalendar :customerDeliverySchedule="settings.customerDeliverySchedules" @change="changeSchedule"></CustomerDeliveryCalendar>
					</el-form-item>
				</el-form>
		  </el-collapse-item>
			<el-collapse-item name="6">
		    <template slot="title">
		      <h3><i class="mdi mdi-clock-end"></i> {{ $t('clients.notifications.notifications') }}</h3>
		    </template>
				<el-form :label-position="'top'" v-if="isInvoicingModuleactive === true">
	    		<el-form-item :label="$t('clients.notifications.activatePaymentReminder')">
			    	<el-switch
						  v-model="reminderActivatedModel"
						  active-color="#5f8fdf"
  						  inactive-color="#dcdfe6">
						</el-switch>
					</el-form-item>
					<el-row v-for="(reminder, index) in settings.invoiceReminders" :key="reminder.id" class="border p-10 b-rad-10 mt-10" :class="{'bg-info-lighter' : !reminderActivatedModel}">
            <el-button  @click="removeInvoiceReminderEvent(index)" size="mini" circle type="danger" style="float: right;  ;margin-left:10px;" ><i class="mdi mdi-delete" style="font-size:15px;"></i></el-button>
            <span class="fs-16 secondary-text">{{$t('clients.notifications.reminderNumber')}}{{index+1}}</span>
						<el-row>
							<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
								<el-form-item>
										<el-input-number
											size="small"
											:controls="false"
											style="width:50px;margin-top:2px;"
											:value="reminder.configuration.nbDays"
											:disabled="!settings.reminderActivated"
											@keyup.native="setInvoiceReminderConfigurationProperty({index, itemProp:{nbDays:isNaN(parseInt($event.target.value))?0:parseInt($event.target.value)}})"
											:min="0"
											:max="90">
										</el-input-number>
								    <span class="ml-10 mr-10">{{$t('clients.days')}}</span>
										<el-select size="small"
											:value="reminder.configuration.type"
											placeholder="Select"
											style="width:120px"
											@change="v=>setInvoiceReminderConfigurationProperty({index,itemProp:{type:v}})"
											:disabled="!reminderActivatedModel">
										  <el-option
										    v-for="item in reminderTypes"
										    :key="item.id"
										    :label="$t('clients.notifications.'+item.value)"
										    :value="item.id">
										  </el-option>
										</el-select>
										<span class="ml-10 mr-10">{{$t('clients.notifications.limitDate')}}</span>
						  	</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
								<el-form-item>
									<span class="ml-10 mr-10">Gabarit personnalisé : </span>
									<el-select
										:value="reminder.email_custom_content_id"

										clearable
										@change="v=>setInvoiceReminderProperty({index,itemProp:{email_custom_content_id:v==''?null:v}})"
										>
								    <el-option
								      v-for="item in invoiceNotificationCustomEmailContent"
								      :key="item.id"
								      :label="item.description"
								      :value="item.id">
								    </el-option>
								  </el-select>
								</el-form-item>
							</el-col>
						</el-row>
					</el-row>
					<el-row v-if="settings.invoiceReminders.length<3 && reminderActivatedModel" class="border mt-20 p-20 b-rad-10 center">
						<el-button type="text" style="width:100%" @click="addInvoiceReminderEvent">Ajouter un rappel</el-button>
					</el-row>
				</el-form>
        <el-form :label-position="'top'">
	    		<el-form-item label="Activer les rappels de réservation?">
			    	<el-switch
						  v-model="reservationNotificationIndModel"
						  active-color="#5f8fdf"
  						  inactive-color="#dcdfe6">
						</el-switch>
					</el-form-item>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
              <el-form-item label="Fréquence :" :required="reservationNotificationIndModel">
                <el-select v-model="reservationNotificationTypeModel" placeholder="Sélectionner une fréquence" :disabled="!reservationNotificationIndModel" :default-first-option="true">
                  <el-option
                    v-for="item in reservationNotificationTypeData"
                    :key="item"
                    :label="$t('notifications.frequency.'+item)"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
              <el-form-item label="Courriel personnalisé :" :required="reservationNotificationIndModel">
                <el-select
                  :disabled="!reservationNotificationIndModel"
                  :default-first-option="true"
                  clearable
                  v-model="reservationNotificationEmailCustomContentModel"
                  value-key="id"
                  >
                  <el-option
                    v-for="item in reservationNotificationCustomEmailContent"
                    :key="item.id"
                    :label="item.description"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
				</el-form>
		  </el-collapse-item>
		</el-collapse>
	</div>
</template>

<script>
// import axios from "axios"
// import deliveryTypAPI from '@/services/API/deliveryType'
import BranchTile from '@/components/Branch-tile'
import eccAPI from '@/services/API/emailCustomContent'
import CustomerDeliveryCalendar from '@/components/customer/Customer-delivery-calendar'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
	name: 'CustomerSettings',
	props: {
		customerId : Number,
		listTags : Array
	},
	data() {
		return {
			activeName : '1',
			location : null,
			reminderTypes : [{id:1, value:'BEFORE'},{id:2, value:'AFTER'}],
			emailCustomContents : [],
      reservationReminder: {},
		}

	},
	computed : {
    reservationNotificationTypeData(){
      return ['WEEKLY', 'BIWEEKLY', 'MONTHLY', 'QUATERLY', 'YEARLY']
    },
		customerClasseModel : {
			set(customerClass){this.setCustomerSettingProperty({customerClass})},
			get(){return this.settings.customerClass;}
		},
		tagsModel : {
			set(tags){this.setCustomerSettingProperty({tags})},
			get(){return this.settings.tags;}
		},
		currencyModel : {
			set(currency){this.setCustomerSettingProperty({currency})},
			get(){return this.settings.currency;}
		},
		languageModel : {
			set(language){this.setCustomerSettingProperty({language})},
			get(){return this.settings.language;}
		},
		paymentMethodModel : {
			set(paymentMethods){this.setCustomerSettingProperty({paymentMethods})},
			get(){return this.settings.paymentMethods;}
		},
		termModel : {
			set(term){this.setCustomerSettingProperty({term})},
			get(){return this.settings.term;}
		},
		taxesModel : {
			set(taxes){this.setCustomerSettingProperty({taxes})},
			get(){return this.settings.taxes;}
		},
		taxableModel : {
			set(taxable){this.setCustomerSettingProperty({taxable})},
			get(){return this.settings.taxable;}
		},
		lateFeeActivatedModel : {
			set(lateFeeActivated){this.setCustomerSettingProperty({lateFeeActivated})},
			get(){return this.settings.lateFeeActivated;}
		},
		invoiceBeforeProcessingModel : {
			set(invoice_before_processing){this.setCustomerSettingProperty({invoice_before_processing})},
			get(){return this.settings.invoice_before_processing}
		},
		onlineInvoiceIndModel : {
			set(online_invoicing_ind){this.setCustomerSettingProperty({online_invoicing_ind})},
			get(){return this.settings.online_invoicing_ind}
		},
		indTypeFeeModel : {
			set(indTypeFee){this.setCustomerSettingProperty({indTypeFee})},
			get(){return this.settings.indTypeFee;}
		},
		feeModel : {
			set(fee){this.setCustomerSettingProperty({fee})},
			get(){return this.settings.fee;}
		},
		gracePeriodModel : {
			set(gracePeriod){this.setCustomerSettingProperty({gracePeriod})},
			get(){return this.settings.gracePeriod;}
		},
		deliveryTypeModel : {
			set(deliveryType){this.setCustomerSettingProperty({deliveryType})},
			get(){return this.settings.deliveryType;}
		},
		locationModel : {
			set(location){this.setCustomerSettingProperty({location})},
			get(){return this.settings.location;}
		},
		reminderActivatedModel : {
			set(reminderActivated){this.setCustomerSettingProperty({reminderActivated})},
			get(){return this.settings.reminderActivated;}
		},
    reservationNotificationIndModel : {
			set(reservationNotificationInd){this.setCustomerSettingProperty({reservationNotificationInd})},
			get(){return this.settings.reservationNotificationInd;}
		},
    reservationNotificationTypeModel : {
      set(reservationNotificationType){this.setCustomerSettingProperty({reservationNotificationType})},
      get(){return this.settings.reservationNotificationType;}
    },
    reservationNotificationEmailCustomContentModel : {
      set(reservationNotificationEmailCustomContent){this.setCustomerSettingProperty({reservationNotificationEmailCustomContent})},
      get(){return this.settings.reservationNotificationEmailCustomContent;}
    },
		reminderTypeModel : {
			set(reminderType) {this.setCustomerSettingProperty({reminderType})},
			get(){return this.settings.reminderType}
		},
		nbDayReminderModel : {
			set(nbDaysReminder){this.setCustomerSettingProperty({nbDaysReminder})},
			get(){return this.settings.nbDaysReminder;}
		},
		lateFeeReminderActivatedModel : {
			set(lateFeeReminderActivated){this.setCustomerSettingProperty({lateFeeReminderActivated})},
			get(){return this.settings.lateFeeReminderActivated;}
		},
    invoiceNotificationCustomEmailContent(){
      return _.filter(this.emailCustomContents, ecc => ecc.type.code === 'INVOICE_REMINDER')
    },
    reservationNotificationCustomEmailContent(){
      return _.filter(this.emailCustomContents, ecc => ecc.type.code === 'RESERVATION_REMINDER')
    },
		...mapGetters('controlData', [ 'deliveryTypesByLanguage','onlinePaymentMethods', 'getFormattedPrivateImportPatriculierSAQBranch', 'getFormattedPrivateImportTPSAQBranch']),
		...mapState('controlData', ['locations','deliveryTypes', 'paymentMethods','customerClasses','languages','currencies','taxes']),
		...mapState('customerEditor',['settings','terms']),
		...mapGetters(['isInvoicingModuleactive'])
   },
	methods : {
		fetchEmailCustomContent(){
			eccAPI.fetchEmailCustomContent()
        .then(emailCustomContents=>{
          this.emailCustomContents = emailCustomContents;
        })
		},
		addInvoiceReminderEvent(){
			this.addInvoiceReminder({type:'INVOICE_REMINDER',configuration:{type :1, nbDays:this.settings.invoiceReminders.length==1?15:30},email_custom_content_id:null})
		},
		removeInvoiceReminderEvent(index){
			this.removeInvoiceReminder(index)
		},
		changeSchedule({mode, schedule}){
			this.setSchedule({mode, schedule});
		},
		searchLocation(queryString, cb){
			let locations = this.locations;

			if (this.settings.deliveryType != null && (this.settings.deliveryType.choice_custom_info === 'SAQ' || this.settings.deliveryType.choiceCustomInfo === 'SAQ')) {
				if (_.get(this.settings, 'customer.customer_class.ind') === 'TITULAIRE' || _.get(this.settings, 'customer.class.ind') === 'TITULAIRE') {
					locations = this.getFormattedPrivateImportTPSAQBranch;
				} else {
					locations = this.getFormattedPrivateImportPatriculierSAQBranch;
				}
			}

			var results = queryString ? locations.filter(this.createLocationFilter(queryString)) : locations;
			cb(results);
			},
    createLocationFilter(queryString) {
      return (location) => {

        return (location.content.number.toLowerCase().indexOf(queryString.toLowerCase()) !== -1 ||
                this.removeAccent(location.content.city.toLowerCase()).indexOf(this.removeAccent(queryString.toLowerCase())) !== -1 ||
               this.removeAccent(location.content.address.toLowerCase()).indexOf(this.removeAccent(queryString.toLowerCase())) !== -1);
      };
    },
    removeAccent(str){
      return str
         .replace(/[áàãâä]/gi,"a")
         .replace(/[éè¨ê]/gi,"e")
         .replace(/[íìïî]/gi,"i")
         .replace(/[óòöôõ]/gi,"o")
         .replace(/[úùüû]/gi, "u")
         .replace(/[ç]/gi, "c")
         .replace(/[ñ]/gi, "n")
         .replace(/[^a-zA-Z0-9]/g,"");
    },
		selectDeliveryType(val){
			if(val.choice_custom_info!=null){
				this.fetchLocations(val.choice_custom_info);
			}
		},
		handleSelectLocation(location){
			this.setCustomerSettingProperty({location});
			this.location =location.content.number + ' - ' + location.content.address + ", " + location.content.city;
		},
		...mapActions('controlData',['fetchCustomerClasses','fetchCurrencies','fetchLanguages','fetchPaymentMethods','fetchDeliveryTypes','fetchLocations','fetchTaxes']),
		...mapActions('customerEditor',['fetchDefaultCustomerSettings','setCustomerSettingProperty','setSchedule','addInvoiceReminder','removeInvoiceReminder','setInvoiceReminderConfigurationProperty','setInvoiceReminderProperty'])

	},
	components : {
		BranchTile,
		CustomerDeliveryCalendar
	},
	mounted(){
		if(this.settings.location!=null){
			// let clonedLocation = _.cloneDeep(this.settings.location);

			this.handleSelectLocation(this.settings.location);

		}
		if(this.settings.deliveryType!=null && this.settings.deliveryType.choice_custom_info!=null){
				this.fetchLocations(this.settings.deliveryType.choice_custom_info);
		}
		this.fetchCustomerClasses();
		this.fetchPaymentMethods();
		this.fetchDeliveryTypes();
		this.fetchEmailCustomContent();


		this.fetchTaxes()
			.then(()=>{
				if(this.customerId==null){
					this.setCustomerSettingProperty({taxes:this.taxes})
				}
			})
	},
	watch : {

	}
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables';

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:60px;
  // margin-left:-40px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}


</style>
